export const STATION_API_ENDPOINT = "https://station-api-production-3272.up.railway.app"
